import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const getCJWUploadHistory = async (params) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    // let queryParams = new URLSearchParams(params).toString();
    // const apiUrl = localDatabaseUrls.baseURL + localDatabaseUrls.serviceURL.costUploadHistory + (queryParams ? "?" + queryParams : "")
    // const apiUrl = "https://dog.ceo/api/breeds/list/all";
    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwUploadHistory}`;

    const response =  await getAPI(apiUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
        return response.json();
    } else {
        const errorData = await response.json();
        response.status !== 200 ? AlertManager.error(errorData.message, {contactSupport: false}) : AlertManager.error(response.statusText, {ContactSupport: false});
        // response.status === 404 ? AlertManager.error("File not found in bucket", { contactSupport: false }) : AlertManager.error("Error downloading file", { contactSupport: false });
        return { content: [], totalPages: 0 };
    }

};
